import { track } from 'src/lib/analytics/utils';
import { DemoTestBucket } from 'src/lib/getDemoState';

/**
 * When user click login button in PopupLineDemoLogin
 */
export function trackDemoRedirect(bucket: DemoTestBucket) {
  track('DemoLINELogin', {
    bucket,
  });
}

/**
 * When user successfully migrated from demo mode
 */
export function trackDemoSuccessMigration(bucket: DemoTestBucket) {
  track('DemoLINELoginSuccess', {
    bucket,
  });
}
